var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertising-box"},[_c('el-link',{attrs:{"href":_vm.adv.url,"target":"_blank","underline":false}},[_c('img',{attrs:{"src":_vm.adv.img,"lazy":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }